export default __webpack_public_path__ + "static/media/lsp-abi@3x.196902a6.png";